// extracted by css-extract-rspack-plugin
export default {"root":"root-EW3iLg","item":"item-MUioUM"};